var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{class:{ disabled: _vm.disabled },attrs:{"size":"sm","type":_vm.disabled ? 'secondary' : 'default',"disabled":_vm.disabled},on:{"click":_vm.handlePrint}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }